import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

// Shared, cached reads for the rental CRM. All consumers reuse the same query keys,
// so navigating between Bookings / Calendar / Dashboard reuses the 60s cache instead
// of refetching the (large) bookings payload on every tab click.
export function useBookings(options = {}) {
  return useQuery({
    queryKey: ["bookings"],
    queryFn: async () => (await api.get("/bookings")).data,
    ...options,
  });
}

export function useVehicles(options = {}) {
  return useQuery({
    queryKey: ["vehicles"],
    queryFn: async () => (await api.get("/vehicles")).data,
    ...options,
  });
}

export function useChauffeurs(options = {}) {
  return useQuery({
    queryKey: ["chauffeurs"],
    queryFn: async () => (await api.get("/chauffeurs")).data,
    ...options,
  });
}

// Call after any write so the shared caches refresh in the background (the UI keeps
// showing current data while the refetch happens — no full-page reload flash).
export function useInvalidateRental() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["bookings"] });
    qc.invalidateQueries({ queryKey: ["vehicles"] });
    qc.invalidateQueries({ queryKey: ["chauffeurs"] });
    qc.invalidateQueries({ queryKey: ["dashboard-summary"] });
  };
}
